import { RichText } from "@wordpress/block-editor";
import React from "react";

const VideoBox = ({ heading, content, updateVideo, index }) => {
  return (
    <div className="videoText">
      <div className="content">
        <RichText tagName="h3" value={heading} onChange={(value) => updateVideo("heading", value, index)} />
        <RichText tagName="p" value={content} onChange={(value) => updateVideo("content", value, index)} />
      </div>
    </div>
  );
};

export default VideoBox;
